import React from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import CraverBreadCrumb from '../share/CraverBreadCrumb';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import DisplayResources from '../crud/DisplayResources';
import { resourceFields, reportsPageTableRows } from '../../data/Constants';
import { commonResourceStyle, reportsPageStyle, generalDialogStyles } from '../../css/style';
import { connect } from 'react-redux';
import { getAdmin } from '../../selectors';
import { craverStaffAddress } from '../../utils/Functions';
import GeneralDialog from '../share/GeneralDialog';
import { checkIsAuthorized } from '../../utils/AuthorizationChecks';
import SearchableSelect from '../share/SearchableSelect';
import { getSearchableEntities } from '../../domains/Restrictions';

const styles = commonResourceStyle();
const reportStyles = reportsPageStyle();
const dialogStyles = generalDialogStyles();

class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLocation: [],
    };
  }

  componentDidMount = async () => {
    await this.getReportsResources();
  }

  componentDidUpdate = async (prevProps) => {
    const { apiToken } = this.props;
    if (prevProps.apiToken !== apiToken) {
      await this.getReportsResources();
    }
  }

  onChangeSetLocation = (value) => {
    this.setState({ selectedLocation: [value] });
  }

  getReportsResources = () => {
    const { actions, apiToken } = this.props;
    actions.getAllResources(apiToken, 'locations').then((res) => {
      const allLocation = [{ label: 'All', value: 0 }];
      const searchableLocations = allLocation.concat(getSearchableEntities(res));
      this.setState({ searchableLocations });
    });
  }

  render() {
    const {
      match,
      actions,
      apiToken,
      admin,
    } = this.props;
    const { resource, resourceId, subResource } = match.params;

    if (sessionStorage.getItem('isAuthorized') === null) {
      const isAuthorized = checkIsAuthorized(admin, 'reports', null, 'view');
      sessionStorage.setItem('isAuthorized', isAuthorized);
    }

    if (!sessionStorage.getItem('isAuthorized')) {
      return (
        <Redirect
          to={{
            pathname: '/unauthorized',
            state: { from: { resource, subResource } },
          }}
        />
      );
    }

    return (
      <div style={styles.container}>
        <div style={styles.resourceHeader}>
          <div style={styles.resourceName}>
            <Typography style={styles.resourceName}>Reports</Typography>
          </div>
          <div style={styles.breadcrumbContainer}>
            <CraverBreadCrumb resource={resource} resourceId={resourceId} subResource={subResource} />
          </div>
        </div>
        <Paper style={styles.paperAboveReports}>
          <div style={reportStyles.container}>
            <Typography style={reportStyles.selectLocationFont}>SELECT LOCATION: (ONLY AVAILABLE FOR SALES REPORTS)</Typography>
            <div style={reportStyles.searchableSelect}>
              <SearchableSelect
                options={this.state.searchableLocations}
                value={this.state.selectedLocation}
                onChange={value => this.onChangeSetLocation(value)}
              />
            </div>
          </div>
        </Paper>
        <Paper style={styles.paper}>
          <DisplayResources
            data={reportsPageTableRows}
            actions={actions}
            fieldNames={resourceFields.reports}
            resourceName="reports"
            apiToken={apiToken}
            viewOnly
            bandedTable
            selectedLocation={this.state.selectedLocation}
          />
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  admin: getAdmin(state),
});

export default withRouter(connect(mapStateToProps)(Reports));
